module.exports = __webpack_public_path__ + "img/3.ba569861.png";